<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>> Drawer ---------------------------------------------------- -->
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<< Drawer ---------------------------------------------------- -->


        <!-- >>> Title ----------------------------------------------------- -->
		<v-toolbar-title class="hidden-sm-and-down">Calendar</v-toolbar-title>
        <!-- <<< Title ----------------------------------------------------- -->


        <!-- >>> Filter: 'Filter for Duties' ------------------------------- -->
        <app-filter style="margin-left: 40px;"></app-filter>
        <!-- <<< Filter: 'Filter for Duties' ------------------------------- -->


        <!-- >>> Reset: 'Reset Calendar' ----------------------------------- -->
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#ab2b7a" v-bind="attrs" v-on="on" depressed elevation="1" x-small class="mt-1" text min-width="0" style="margin-left: 15px; margin-right: 0px; margin-top: 0px !important;" @click="onClick_CalendarReset">
                    <v-icon style="top: 3px;">
                        mdi-delete-forever
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Reset Calendars Filter
            </span>
        </v-tooltip>
        <!-- <<< Reset: 'Reset Calendar' ----------------------------------- -->


        <!-- >>> Switch: 'Tooltips off' ------------------------------------ -->
        <v-switch style="margin-left: 15px;"
            v-model="settingsSwitch_Tooltips"
            hide-details
            color="#ab2b7a"
            @change="onChange_SchedulerTooltipsOff"
            label="Tooltip">
        </v-switch>
        <!-- <<< Switch: 'Tooltips off' ------------------------------------ -->


        <v-spacer />


        <!-- >>> Switch: 'Zoom' --------------------------------------------- -->
		<v-slider
            v-model="zoomLevel"
			max="3"
			min="1"
            :step="1"
            ticks="always"
            :tick-labels="['Overview', '6h', '1h']"
            class="mt-3"
            style="font-size:0.85rem;"
            @input="onInput_zoomSlider">
		</v-slider>
        <!-- <<< Switch: 'Zoom' --------------------------------------------- -->


        <v-spacer />


        <!-- >>> Sdr-Component, Duty Plan Changes Menue -->
        <save-duty-plan-changes-menue style="margin-right: 40px;"></save-duty-plan-changes-menue>
        <!-- <<< Sdr-Component, Duty Plan Changes Menue -->


        <!-- >>> Menue: Filter/Search Calendar ----------------------------- -->
        <filter-menue-view style="margin-right: 80px;" />
        <!-- <<< Menue: Filter/Search Calendar ----------------------------- -->


        <!-- >>> Reset: 'Reset Calendar' ----------------------------------- -->
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#ab2b7a" v-bind="attrs" v-on="on" depressed elevation="1" class="" min-width="0" style="margin-left: 0px; margin-right: 40px;" @click="onClick_CalendarRefresh">
                    <v-icon style="top: 3px; color: #ffffff !important;">
                        mdi-refresh
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Refresh
            </span>
        </v-tooltip>
        <!-- <<< Reset: 'Reset Calendar' ----------------------------------- -->


        <!-- >>> Button: Fullscreen ---------------------------------------- -->
        <bryntum-fullscreen-button />
        <!-- <<< Button: Fullscreen ---------------------------------------- -->
	</v-app-bar>
</template>

<script>
    import { BryntumFullscreenButton } from '@bryntum/scheduler-vue';

    import AppFilter from '../Filter.vue';
    import FilterMenueView from '../FilterMenue.vue';
    import SaveDutyPlanChangesMenue from '../../../../shared/components/core/SaveDutyPlanChangesMenue.vue';

    import { mapActions } from 'vuex';
    import { eventBus } from '../../../../../main';


	export default {
		name: 'CrewplanningAppBar',

        /* >>> *************************************************************** / /* Components */
        components : {

            BryntumFullscreenButton,
            AppFilter,
            FilterMenueView,
            SaveDutyPlanChangesMenue,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // ---------------------------------- Switch, 'Tooltips'
            settingsSwitch_Tooltips: true,
            // >>> ------------------------------
            fixFlightToAircraft: false,
            // >>> ------------------------------
            zoomLevel: 2,

        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            eventBus.$on('resetTooltip', this.onReset_Scheduler_Tooltip);
            eventBus.$on('resetZoomlevel', this.onReset_Scheduler_Zoomlevel);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            eventBus.$off('resetTooltip', this.onReset_Scheduler_Tooltip);
            eventBus.$off('resetZoomlevel', this.onReset_Scheduler_Zoomlevel);

		}, // eo function destroyed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SchedulersPreset'
            ]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_SchedulerTooltipsOff()
            *
            * Desc: Global Tooltip on/off.
            * Note:
            *
            * @param {String} value (Duty to filter fors)
            */
            onChange_SchedulerTooltipsOff: function(event) {

                let me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onChange_SchedulerTooltipsOff');
                eventBus.$emit('tooltip', event);

            }, // eo function onChange_SchedulerTooltipsOff()


            /*******************************************************************
			* onChange_TooltipFixFlightToAircraft()
			*
			* Desc:
            * Note:
            *
			*/
            onChange_TooltipFixFlightToAircraft: function(value) {

                const me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onChange_TooltipFixFlightToAircraft');

            }, // eo function onChange_TooltipFixFlightToAircraft()


            /*******************************************************************
			* onInput_zoomSlider()
			*
			* Desc: Emit Event for going backwards in date range.
            * Note: SliderValue   View   ZoomLevel
            *       1             Small  12
            *       2             Normal 15
            *       3             Large  18
            *
            * @param {number} value (Slider value 1-3)
            *
			*/
            onInput_zoomSlider: function(value) {

                const me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onInput_zoomSlider');
                if (value === 1) {
                    me.actn_set_SchedulersPreset('overviewPreset');
                } else if(value === 2) {
                    me.actn_set_SchedulersPreset('normalPreset');
                } else if(value === 3) {
                    me.actn_set_SchedulersPreset('hourPreset');
                }

            }, // eo function onInput_zoomSlider()


            /*******************************************************************
			* onClick_CalendarReset()
			*
			* Desc: Emit
            * Note:
            *
			*/
            onClick_CalendarReset: function(value) {

                const me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onClick_CalendarReset');
                eventBus.$emit('resetcalendar');

            }, // eo function onClick_CalendarReset()




            /******************************************************************* 'Listeners - Emit''
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Tooltip on/off Reset'
            * onReset_Scheduler_Tooltip()
            *
            * Desc: Reset(s) Tooltip On/Off.
            * Note: Emitted in FilterMenue.vue
            *
            */
            onReset_Scheduler_Tooltip: function() {

                let me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onReset_Scheduler_Tooltip');
                this.settingsSwitch_Tooltips = true;

            }, // eo function onReset_Scheduler_Tooltip()


            /******************************************************************* 'Zoomlevel  Reset'
            * onReset_Scheduler_Zoomlevel()
            *
            * Desc: Reset(s) Zoomlevel.
            * Note: Emitted in 'FilterMenue.vue'
            *
            */
            onReset_Scheduler_Zoomlevel: function() {

                let me = this;


                me.$toc('>>> crewplanning/components/core/AppBar.vue >>> onReset_Scheduler_Zoomlevel');
                this.zoomLevel = 2;

            }, // eo function onReset_Scheduler_Zoomlevel()


            /*******************************************************************
			* onClick_CalendarRefresh()
			*
			* Desc: Emit
            * Note:
            *
			*/
            onClick_CalendarRefresh: function(value) {

                eventBus.$emit('refreshcalendar');

            }, // eo function onClick_CalendarRefresh()

        } // eo methods{}
        /* <<< ****************************************************************/

	};
</script>
